module.exports = __webpack_public_path__ + "img/ph.ph801b5ef.svg";